<template>
  <!-- width="350px" -->
  <sidebar-menu
    :menu="getMenu"
    :collapsed="collapsed"
    width="18vw"
    widthCollapsed="50px"
    @collapse="$emit('collapse')"
    style="z-index:9999;"
    @itemClick="onItemClick"
  ></sidebar-menu>
</template>
<script>
// old version 2.4.1
import { SidebarMenu } from 'vue-sidebar-menu';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';
import LogoImage from './LogoImage.vue';
import axios from '@/axios/axios.js';
import { mapMutations } from 'vuex';
import { UserRoles } from '@/util/UtilService.js';

export default {
  components: {
    SidebarMenu
  },
  props: {
    collapsed: {
      type: Boolean,
      required: false
    }
  },
  watch: {
    getNumOfNotifications() {
      if (this.$store.getters.getTotalNumberOfNotifications > 0) {
        this.$el.querySelector('.fa-bell').style.backgroundColor = '#c03';
      } else {
        this.$el.querySelector('.fa-bell').style.backgroundColor = '#1e1e21';
      }
    }
  },
  computed: {
    getNumOfNotifications() {
      return this.$store.getters.getTotalNumberOfNotifications;
    },
    getMenu() {
      let hasZeroCommunities = false;
      let activeCommunity;
      let activeCommunityId;
      let activeCommunityName = 'Ne postoje zajednice';
      if (
        this.$store.getters.getActiveCommunity &&
        this.$store.getters.getActiveCommunity.community_id
      ) {
        activeCommunity = this.$store.getters.getActiveCommunity;
        activeCommunityId = activeCommunity.community_id;

        activeCommunityName =
          activeCommunity.address +
          ' ' +
          activeCommunity.street_number +
          ', ' +
          activeCommunity.municipality_name;
      } else {
        hasZeroCommunities = true;
      }

      let data = [
        {
          header: true,
          title: 'Moj Komšija',
          component: LogoImage
        },
        {
          header: true,
          title: 'Upravljanje'
        },

        {
          href: '/',
          title: 'Izaberite zajednicu',
          icon: 'fas fa-map-pin',
          disabled: hasZeroCommunities
        },
        {
          href: '/dashboard',
          title: 'Upravljanje svim zajednicama',
          icon: 'fas fa-tachometer-alt',
          disabled: false
        },
        // {
        //   href: '/new-community',
        //   title: 'Nova zajednica',
        //   icon: 'fas fa-plus-square'
        // },
        {
          href: '/contractors',
          title: 'Serviseri',
          icon: 'fas fa-toolbox',
          disabled: false
        },
        // {
        //   href: '/projects',
        //   title: 'Projekti',
        //   icon: 'fas fa-clipboard-list',
        //   disabled: false
        // },
        {
          href: '/projects',
          title: 'Projekti',
          icon: 'fas fa-clipboard-list',
          disabled: false
        },
        {
          header: true,
          title: 'Aktivna zajednica'
        },
        {
          title: activeCommunityName,
          icon: 'fas fa-building',
          child: [],
          disabled: hasZeroCommunities
        },
        {
          header: true,
          title: 'Akcije zajednice'
        },
        {
          href: '/community/' + activeCommunityId + '/members',
          title: 'Detalji',
          icon: 'fas fa-info-circle',
          disabled: hasZeroCommunities
        },
        {
          href: '/community/' + activeCommunityId + '/infrastructure',
          title: 'Infrastruktura',
          icon: 'fas fa-tools',
          disabled: hasZeroCommunities
        },
        {
          href: '/community/' + activeCommunityId + '/tickets',
          title: 'Tiketi',
          icon: 'fa fa-ticket-alt',
          disabled: hasZeroCommunities
        },
        {
          href: '/community/' + activeCommunityId + '/reminders',
          title: 'Podsetnici',
          icon: 'fas fa-calendar-check',
          disabled: hasZeroCommunities
        },
        {
          href: '/community/' + activeCommunityId + '/posts',
          title: 'Objave',
          icon: 'fas fa-newspaper',
          disabled: hasZeroCommunities
        },
        {
          href: '/community/' + activeCommunityId + '/polls',
          title: 'Glasanja',
          icon: 'fas fa-chart-bar',
          disabled: hasZeroCommunities
        },
        // {
        //   href: '/community/' + activeCommunityId + '/finances',
        //   title: 'Blagajna',
        //   icon: 'fas fa-cash-register',
        //   disabled: hasZeroCommunities
        // },
        {
          href: '/community/' + activeCommunityId + '/events',
          title: 'Događaji',
          icon: 'fas fa-calendar-alt',
          disabled: hasZeroCommunities
        },
        {
          header: true,
          title: 'Profil'
        },
        // {
        //   href: '/inbox',
        //   title: 'Poruke',
        //   icon: 'fas fa-comment-dots',
        //   badge:
        //     this.$store.getters.getNumberOfUnreadMessages === 0
        //       ? null
        //       : {
        //           text: this.$store.getters.getNumberOfUnreadMessages
        //         },
        //   disabled: hasZeroCommunities
        // },
        {
          href: '/notifications/',
          title: 'Notifikacije',
          icon: 'fas fa-bell',
          badge:
            this.$store.getters.getTotalNumberOfNotifications === 0
              ? null
              : {
                  text: this.$store.getters.getTotalNumberOfNotifications
                },
          disabled: hasZeroCommunities
        },
        // {
        //   href: '/user-management',
        //   title: 'Upravljanje upravnicima',
        //   icon: 'fas fa-users',
        //   disabled: false
        // },
        {
          href: '/profile',
          title: 'Vaš profil',
          icon: 'fas fa-user'
        },
        {
          href: '/logout',
          title: 'Odjavi se',
          icon: 'fas fa-sign-out-alt'
        }
      ];
      let isSuperManager =
        this.$store.getters.getUser.roles.indexOf(UserRoles.SUPER_MANAGER) !=
        -1;
      if (isSuperManager) {
        data.splice(4, 0, {
          href: '/new-community',
          title: 'Nova zajednica',
          icon: 'fas fa-plus-square'
        });
        data.splice(18, 0, {
          href: '/user-management',
          title: 'Upravljanje upravnicima',
          icon: 'fas fa-users',
          disabled: false
        });
      }

      this.$store.commit(
        'setLastActiveCommunities',
        this.$store.getters.getLastActiveCommunities
      );
      let tableData = this.$store.getters.getLastActiveCommunitiesImploded;
      let dropdown = data.find(function(el) {
        if (el.icon == 'fas fa-building') {
          return el;
        }
      });
      if (dropdown) {
        if (tableData && tableData.length == 1) {
          dropdown.child = null;
        } else {
          tableData.forEach(community => {
            if (
              this.$store.getters.getActiveCommunity &&
              this.$store.getters.getActiveCommunity.community_id &&
              this.$store.getters.getActiveCommunity.community_id ==
                community.id
            ) {
              return;
            }
            dropdown.child.push({
              href: '/community/' + community.id,
              title: community.name,
              icon: 'fas fa-building',
              communityId: community.id
            });
          });
        }
      }

      let tickets = data.find(function(el) {
        if (el.title == 'Tiketi') {
          return el;
        }
      });

      // if (tickets) {
      // }
      return data;
    }
  },

  methods: {
    ...mapMutations([
      'setCommunities',
      'loadingStarted',
      'loadingFinished',
      'setActiveCommunity'
    ]),
    onItemClick(event, item) {
      if (item.communityId) {
        this.$store.commit('setActiveCommunity', item.communityId);
      } else {
        let dropdown = document.querySelector('.vsm-dropdown');
        if (!dropdown) {
          // this.loadingStarted();
          axios
            .get('user/get-communities')
            .then(res => {
              let isSuperManager =
                this.$store.getters.getUser.roles.indexOf(
                  UserRoles.SUPER_MANAGER
                ) != -1;
              let communitiesOfManager = [];
              if (res.data) {
                communitiesOfManager = res.data.filter(
                  c => c.is_manager === '1'
                );
              }

              // check if super manager. If he is allow to have zero communities
              if (communitiesOfManager.length === 0 && !isSuperManager) {
                // this.loadingFinished();
                localStorage.removeItem('k-t');
                this.$router.push('/logout');
                return;
              }
              for (let c of communitiesOfManager) {
                c.notifications = {
                  polls: 0,
                  tickets: 0,
                  members: 0,
                  unreadNotificationsCount: 0
                };
              }
              this.setCommunities(communitiesOfManager);
              let data = JSON.parse(localStorage.getItem('k-d'));
              data.communities = communitiesOfManager;
              localStorage.setItem('k-d', JSON.stringify(data));
              this.$store.commit(
                'setLastActiveCommunities',
                this.$store.getters.getLastActiveCommunities
              );
              if (
                this.$store.getters.getActiveCommunity &&
                this.$store.getters.getActiveCommunity.community_id
              ) {
                let activeCommunityId = this.$store.getters.getActiveCommunity
                  .community_id;
                var index = communitiesOfManager
                  .map(function(e) {
                    return e.community_id;
                  })
                  .indexOf(activeCommunityId);
                if (index === -1 && communitiesOfManager[0]) {
                  this.setActiveCommunity(communitiesOfManager[0].community_id);
                }
              }
              // this.loadingFinished();
            })
            .catch(e => {
              // this.loadingFinished();
              localStorage.removeItem('k-t');
              this.$router.push('/logout');
              return;
            });
        }
      }
    }
  }
};
</script>

<style lang="scss">
.v-sidebar-menu .vsm-mobile-bg,
.v-sidebar-menu.vsm-default .vsm-item.first-item.open-item > .vsm-link {
  background-color: var(--primary-color) !important;
}

.v-sidebar-menu .vsm-item.first-item.active-item > .vsm-link,
.v-sidebar-menu .vsm-item.first-item.parent-active-item > .vsm-link {
  box-shadow: 3px 0px 0px 0px var(--primary-color) inset !important;
}

// .v-sidebar-menu .vsm-item.open-item {
//   height: 50px;
//   .vsm-link {
//     height: 100%;
//     text-overflow: ellipsis;
//     white-space: nowrap;
//     overflow: hidden;
//     padding-right: 32px;
//   }
// }

.collapse-btn {
  outline-color: transparent !important;
}

.page-link {
  color: gray;
}
.page-link:focus {
  box-shadow: none;
}

.v-sidebar-menu .vsm-badge {
  background-color: #c03 !important;
  color: white;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 1.25rem;
  font-size: 0.75rem;
  text-align: center;
  line-height: 1.25rem;
  min-width: 1.25rem;
  display: inline-block;
}

.v-sidebar-menu .vsm-badge {
  animation: 0.2s slideInLeft;
  margin-right: 5px;
}
.vsm-title {
  // overflow: hidden;
  margin-right: 35px;
  white-space: normal !important;
  padding-left: 24px;
  // text-overflow: ellipsis;
}

.v-sidebar-menu .vsm-item.first-item > .vsm-link > .vsm-title {
  padding-left: 40px;
}

.v-sidebar-menu.vsm-collapsed > div:not(.vsm-list) {
  white-space: nowrap;
  width: unset !important;
  // padding-right: 50px;
}
.v-sidebar-menu.vsm-collapsed > div:not(.vsm-list) .vsm-item .vsm-link {
  padding-right: 24px;
  display: flex;
}
.v-sidebar-menu.vsm-collapsed
  > div:not(.vsm-list)
  .vsm-item.open-item
  .vsm-link {
  padding-right: 44px;
}
</style>
